import { Richtext } from '@/components/Richtext';
import Video from '@/components/Video';
import { formatDate } from '@/utilities/dateUtils';
import replaceAbbreviations from '@/utilities/replaceAbbreviations';

export default function TimelineBox({
  date,
  title = undefined,
  text = undefined,
  image = undefined,
  video = undefined,
  rotation = 0,
}) {
  return (
    <div className="TimelineBox">
      <div className="TimelineBox__dateBox">{formatDate(date, 'Default')}</div>
      <div className="TimelineBox__contentBox">
        {(image || video) && (
          <div className="TimelineBox__content TimelineBox__content--image">
            {image && (
              <figure
                className="TimelineBox__image Image Image--fullwidth Image--boxed"
                style={{
                  transform: `rotate(${rotation}deg)`,
                }}
              >
                <div className="Image__container">
                  <img
                    className="Image__img"
                    src={image['path']}
                    alt={image['title']}
                    loading="lazy"
                  />
                </div>
              </figure>
            )}
            {video && <Video url={video} />}
          </div>
        )}
        <div className="TimelineBox__content">
          {title && <span className="TimelineBox__title">{title}</span>}
          {text && (
            <Richtext html>{replaceAbbreviations(text).__html}</Richtext>
          )}
        </div>
      </div>
    </div>
  );
}
